import { LitElement, html, svg } from 'lit';

export class IconClose16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Kryss</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m12.5 3.5-9 9M3.5 3.5l9 9"></path></svg>`; }
}
if (!customElements.get('f-icon-close16', IconClose16)) {
  customElements.define('f-icon-close16', IconClose16);
}